export default {
  app_title: '生豪创艺',
  app_version: __COMFYUI_FRONTEND_VERSION__
}
